<template>
  <div>

    <!-- rakuchat -->
    <RCchatHistory v-if="complainDetail.type == 'RAKUCHAT'" :id="complainDetail.id" />
    <!-- chatwork -->
    <CWchatHistory v-if="complainDetail.type == 'CHATWORK'" :id="complainDetail.id" />
  </div>
</template>
<script>
import RCchatHistory from './chatHistory/RCchatHistory.vue'
import CWchatHistory from './chatHistory/CWchatHistory.vue'
export default {
  components: {
    RCchatHistory,
    CWchatHistory
  },
  props: {
    complainDetail: { type: Object }
  },
  data() {
    return {

    };
  },
  methods: {

  }
}
</script>
<style lang='scss' scoped></style>
